/**
 * Opens the supplement facts panel in a modal.
 *
 * showModal() rather than show(), so the browser supplies the backdrop, traps
 * focus, closes on Escape and restores focus to the button afterwards — all of
 * which would otherwise have to be written by hand.
 */
(() => {
  const dialog = document.querySelector('[data-ms-facts]');
  if (!dialog) return;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (target.closest('[data-ms-facts-open]')) {
      const image = dialog.querySelector('img');
      if (image && !image.complete) image.loading = 'eager';
      dialog.showModal();
      return;
    }

    if (target.closest('[data-ms-facts-close]')) {
      dialog.close();
      return;
    }

    // A click on the dialog element itself is the area outside the image.
    if (target === dialog) dialog.close();
  });
})();
